import { createAction } from 'redux-actions';
import { SET_CURRENT_THREAD_LIST } from 'conversations-inbox-lib/views/public/constants';
export const setCurrentThreadList = createAction(SET_CURRENT_THREAD_LIST, threadList => ({
  threadList
}));